// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"f19983d5","578":"074dfe87","823":"a7e8de2a"}[chunkId] + ".chunk.js";
};